import PropTypes from 'prop-types';
import { ActionRow, Stack } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';

import messages from '@src/courseware/course/sequence/messages';
import UnitTranslationSelector from './translation-button';
import BookmarkButton from './BookmarkButton';

const UnitTitle = ({
  dispatch,
  id,
  navigation,
  unitId,
  unit,
}) => {
  const { formatMessage } = useIntl();
  const isProcessing = unit.bookmarkedUpdateState === 'loading';

  return (
    <Stack gap={3} className="mt-n3">
      <ActionRow className="mx-n3">
        <BookmarkButton
          unitId={unit.id}
          isBookmarked={unit.bookmarked}
          isProcessing={isProcessing}
          dispatch={dispatch}
        />
        <UnitTranslationSelector
          {...{
            id,
            unitId,
            unitTitle: unit.title,
            dispatch,
            isLegacyButton: false,
          }}
        />
        <ActionRow.Spacer />
        {navigation}
      </ActionRow>
      <div>
        <h3 className="h3">{unit.title}</h3>
        <p className="sr-only">{formatMessage(messages.headerPlaceholder)}</p>
      </div>
    </Stack>
  );
};

UnitTitle.propTypes = {
  dispatch: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  navigation: PropTypes.node.isRequired,
  unitId: PropTypes.string.isRequired,
  unit: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    bookmarked: PropTypes.bool.isRequired,
    bookmarkedUpdateState: PropTypes.string,
  }).isRequired,
};

export default UnitTitle;
